import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  CircularProgress,
  Box,
  Typography,
} from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { produtoService, Produto } from '../../services/produto';

interface SelectProdutoUnificarProps {
  value?: number;
  onChange: (value: number) => void;
  label?: string;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  excludeId?: number; // ID para excluir da lista (produto atual)
}

const SelectProdutoUnificar: React.FC<SelectProdutoUnificarProps> = ({
  value,
  onChange,
  label = 'Produto para unificar',
  required = false,
  error = false,
  helperText,
  disabled = false,
  fullWidth = true,
  excludeId,
}) => {
  const { data: produtos = [], isLoading } = useQuery({
    queryKey: ['produtos'],
    queryFn: produtoService.getAll,
  });

  // Filtrar produtos, excluindo o produto atual se especificado
  const produtosFiltrados = excludeId 
    ? produtos.filter(produto => produto.id !== excludeId)
    : produtos;

  const handleChange = (event: any) => {
    onChange(Number(event.target.value));
  };

  return (
    <FormControl fullWidth={fullWidth} required={required} error={error} disabled={disabled}>
      <InputLabel id="produto-unificar-label">{label}</InputLabel>
      <Select
        labelId="produto-unificar-label"
        value={value || ''}
        onChange={handleChange}
        label={label}
        disabled={isLoading || disabled}
      >
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
            <CircularProgress size={20} />
          </Box>
        ) : produtosFiltrados.length === 0 ? (
          <MenuItem disabled>
            <Typography color="text.secondary">
              Nenhum produto disponível
            </Typography>
          </MenuItem>
        ) : (
          produtosFiltrados.map((produto) => (
            <MenuItem key={produto.id} value={produto.id}>
              <Box>
                <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                  {produto.nomeProduto}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Ref: {produto.referencia} | R$ {produto.precoVenda.toFixed(2)}
                </Typography>
              </Box>
            </MenuItem>
          ))
        )}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default SelectProdutoUnificar;
